import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  saveAuthData,
  saveModule,
  saveStoreData,
  saveUserData,
  setAttribute,
  setRaiseIssue,
} from "../../features/login/LoginSlice";

export const useAuthPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authToken = useSelector(
    (state) => state.loginSlice.authData?.accessToken
  );
  const { authData } = useSelector((state) => state.loginSlice);


  const handleAuthFlow = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const auth = JSON.parse(queryParams.get("auth"));
    const navbar = queryParams.get("navbar") ? queryParams.get("navbar") : [];
    const authorizations = JSON.parse(queryParams.get("authorization"));
    const isAdmin = JSON.parse(queryParams.get("isAdmin"));
    const storeId = queryParams.get("storeId");
    const raiseIssue = queryParams.get("raiseIssue");
    const attributes = queryParams.get("attribute");
    const tenantId =
      queryParams.get("tenant_id") ||
      queryParams.get("tenantId") ||
      queryParams.get("storeId");

    
   

    dispatch(setRaiseIssue(raiseIssue === "true"));
    dispatch(setAttribute(attributes ? JSON.parse(attributes) : {}));
    dispatch(saveStoreData({ storeId: tenantId || null }));
    const secondAppUrl = `${process.env.REACT_APP_API_FRONTEND_URL_NODE}/login`;
    //console.log(process.env.REACT_APP_API_FRONTEND_URL_NODE);

    if (!authToken && !auth) {
      const redirectUrl = window.location.origin + window.location.pathname;
      const applicationName = "IGM Version 2";
      window.location.href = `${secondAppUrl}?redirectUrl=${encodeURIComponent(
        redirectUrl
      )}&appName=${encodeURIComponent(applicationName)}`;

      return;
    }

    let canRead = authorizations.includes("IGM_MULTI_STORES");


    dispatch(
      saveAuthData({
        accessToken: auth?.accessToken,
        refreshToken: auth?.refreshToken,
      })
    );

    const userDetails = {
      permissions: authorizations || [],
      isAdmin: isAdmin || false,
    };

    //console.log("User Details:", userDetails);

    dispatch(saveModule(navbar));
    dispatch(saveUserData(userDetails));
    // dispatch(saveStoreData({ storeId: storeId || null }));

    if (!canRead) {
      navigate("/orders");
    } else {

    if (raiseIssue === "true") {
      navigate("/issues/seller");
    } else {
      navigate("/services");
    }
    }
  };

  return {
    handleAuthFlow,
  };
};
